// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetTitle, { WidgetTitleStyles, widgetTitleStyles } from "@bg/App/Components/WidgetTitle";

import * as React from "react";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}
interface CardListHeadingStyles {
    widgetTitle?: WidgetTitleStyles;
}

export const cardListHeadingStyles: CardListHeadingStyles = {};

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return <WidgetTitle extendedStyles={cardListHeadingStyles.widgetTitle} title={heading} viewAllLink={viewAllUrl} />;
};

export default CardListHeading;
